import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import {
  getClubBookingByID,
  getClubBookingTotalPrice,
  getClubBookingLimitedPlacesDetails,
  isClubBookingExpanded,
  isClubBookingInBasket,
  hasClubBookingBeenModified,
  isClubBookingSeen,
  isClubBookingReserved,
  doesClubBookingHaveBookings,
  getGoToClubBookingID
} from "state/school_money/selectors";
import {
  addClubBookingToBasket,
  removeClubBookingFromBasket,
  setExpandedClubBooking
} from "state/school_money/actions";

import ExpandingBox from "components/ExpandingBox";
import Highlight from "components/Highlight";
import Button from "components/Button";
import Date from "components/Date";
import ShortDate from "components/ShortDate";
import Currency from "components/Currency";
import WeekdayTable from "components/WeekdayTable";
import AddButton from "components/school_money/AddButton";
import NewIndicator from "components/school_money/NewIndicator";
import BasketModificationModal from "components/school_money/BasketModificationModal";
import AddToBasketConfirmationModal from "components/school_money/AddToBasketConfirmationModal";
import DailyClubSessionInput from "components/school_money/clubs/DailyClubSessionInput";

import "./ClubBooking.css";

class ClubBooking extends React.Component {

  state = {
    isBasketConfirmationModalOpen: false,
    shouldReserveAfterConfirmation: undefined,
    isBasketModificationModalOpen: false
  }

  addToBasket = reserve => {
    this.props.addToBasket(reserve);
    this.props.collapse();
  }

  onBasketConfirmationModalClose = result => {
    if (result) {
      this.addToBasket(this.state.shouldReserveAfterConfirmation);
    }
    this.setState({
      isBasketConfirmationModalOpen: false,
      shouldReserveAfterConfirmation: undefined
    });
  }

  confirmAddToBasket = reserve => {
    if (this.props.limitedPlaces.enabled || this.props.clubBooking.requiresParentalConsent) {
      this.setState({
        isBasketConfirmationModalOpen: true,
        shouldReserveAfterConfirmation: reserve
      });
    } else {
      this.addToBasket(reserve);
    }
  }

  onAddToBasketClick = () => {
    // if the booking is in the basket then show an alert
    if (this.props.isInBasket) {
      this.onReadOnlyClick();
      // add to basket if we have modifications
    } else if (this.props.isModified || this.props.isReserved) {
      this.confirmAddToBasket(false);
    }
  }

  onReserveClick = () => {
    if (this.props.isInBasket) {
      this.onReadOnlyClick();
    } else if (this.props.isModified) {
      this.confirmAddToBasket(true);
    }
  }

  removeFromBasket = () => {
    this.props.removeFromBasket();
  }

  onReadOnlyClick = () => {
    this.setState({ isBasketModificationModalOpen: true });
  }

  /**
   * If the modal was closed with a positive/"yes" then remove from basket
   */
  onBasketModificationModalClose = (result) => {
    if (result) {
     this.removeFromBasket();
    }
    this.setState({ isBasketModificationModalOpen: false });
  }

  render() {

    const { clubBooking, clubBookingID, totalPrice, limitedPlaces, isExpanded, isModified, isInBasket, isSeen, isBooked, isReserved, isHighlighted, expand, collapse } = this.props;
    const { description, startDate, lastModifiedDate, isReservationsEnabled, requiresParentalConsent } = clubBooking.toJS();
    const hasLastModifiedDate = lastModifiedDate !== "";

    let status = null;
    if (isReserved) {
      status = "Reserved";
    } else if (isBooked) {
      status = "Booked";
    }

    const classNames = [ "club-booking" ];
    if (!isModified) {
      classNames.push("club-booking--no-reserve");
    }
    if (!isReserved && !isModified) {
      classNames.push("club-booking--no-add-to-basket");
    }
    if (isInBasket) {
      classNames.push("club-booking--in-basket");
    }

    return (
      <div className={classNames.join(" ")} ref={this.props.innerRef}>
        <BasketModificationModal
          isOpen={this.state.isBasketModificationModalOpen}
          onClose={this.onBasketModificationModalClose}
          itemName="week"
        />
        <AddToBasketConfirmationModal
          type="club"
          isOpen={this.state.isBasketConfirmationModalOpen}
          consentRequired={requiresParentalConsent}
          limitedPlaces={limitedPlaces}
          onClose={this.onBasketConfirmationModalClose}
        />
        <Highlight cssModifier="school_money" isHighlighted={isHighlighted}>
          <ExpandingBox cssModifier="school_money" expanded={isExpanded} onExpand={expand} onCollapse={collapse}>
            <ExpandingBox.Header>
              { isSeen ? null : <NewIndicator className="club-booking__new-indicator" /> }
              <div className="club-booking__header">
                <div className="club-booking__description">{description}</div>
                <div className="club-booking__week-date">W/C <Date date={startDate} /></div>
              </div>
              <div className="club-booking__status">{status}</div>
            </ExpandingBox.Header>
            <ExpandingBox.Body>
              <div className="club-booking__body">
                <div className="club-booking__session-selections">
                  <WeekdayTable cssBlockName="weekly-session-input">
                    { (weekdayIndex, weekdayName) => (
                      <DailyClubSessionInput
                        key={weekdayIndex}
                        clubBookingID={clubBookingID}
                        weekdayIndex={weekdayIndex}
                        weekdayName={weekdayName}
                        onReadOnlyClick={this.onReadOnlyClick}
                      />
                    ) }
                  </WeekdayTable>
                </div>
                { limitedPlaces.enabled ? <div className="club-booking__limited-places">Limited Places</div> : null }
                {
                  isReservationsEnabled ?
                  <div className="club-booking__row">
                    <Button className="club-booking__reserve-button" onClick={this.onReserveClick}>Reserve</Button>
                  </div> :
                  null
                }
                <div className="club-booking__row">
                  <div className="club-booking__total">
                    Total: <Currency className="club-booking__total-amount" amount={totalPrice} />
                  </div>
                  <AddButton className="club-booking__add-button" onClick={this.onAddToBasketClick} />
                </div>
              </div>
              {
                hasLastModifiedDate ?
                <div className="club-booking__last-modified">
                  <span className="club-booking__last-modified-label">Last Modified </span>
                  <span className="club-booking__last-modified-date">
                    <ShortDate date={lastModifiedDate} />
                  </span>
                </div> :
                null
              }
            </ExpandingBox.Body>
          </ExpandingBox>
        </Highlight>
      </div>
    )
  }

}

export default connect(
  (state, { clubBookingID }) => ({
    clubBooking: getClubBookingByID(state, clubBookingID),
    totalPrice: getClubBookingTotalPrice(state, clubBookingID),
    limitedPlaces: getClubBookingLimitedPlacesDetails(state, clubBookingID),
    isExpanded: isClubBookingExpanded(state, clubBookingID),
    isInBasket: isClubBookingInBasket(state, clubBookingID),
    isModified: hasClubBookingBeenModified(state, clubBookingID),
    isSeen: isClubBookingSeen(state, clubBookingID),
    isBooked: doesClubBookingHaveBookings(state, clubBookingID),
    isReserved: isClubBookingReserved(state, clubBookingID),
    isHighlighted: clubBookingID === getGoToClubBookingID(state)
  }),
  (dispatch, { clubBookingID }) => bindActionCreators({
    addToBasket: (reserve) => addClubBookingToBasket(clubBookingID, reserve),
    removeFromBasket: () => removeClubBookingFromBasket(clubBookingID),
    expand: () => setExpandedClubBooking(clubBookingID),
    collapse: () => setExpandedClubBooking(null)
  }, dispatch)
)(ClubBooking);



// WEBPACK FOOTER //
// ./src/components/school_money/clubs/ClubBooking.js